import React, { useEffect, useState } from 'react';
import { Box, MenuItem, Select, Switch, TextField } from '@material-ui/core';
import ReactModal from 'react-modal';
import {
  Coupon,
  CouponPrizeTarget,
  CouponTypes,
} from '../../../../types/coupons';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DateTimePicker from 'react-datetime-picker';
import { AppButton } from '../../ctaButton/button';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import {
  valdiateFinishDate,
  validateStartDate,
} from '../../../../helpers/valdiateStartFinishDates';
import './style.css';
import { CouponHelpers } from '../../../../helpers/couponHelpers';
import { Charity } from '../../../../types/charities';
import CharityImageUploader from '../charity-image-uploader';
import useCharityImage from '../../../general/hooks/useCharityImage';

interface Props {
  charity?: Charity;
  refresh: () => void;
  closeModal: () => void;
  showModal: boolean;
  action: 'create' | 'edit';
}

interface SelectCategories {
  id: string;
  title: string;
  _id?: string;
}

enum CharityCategory {
  ChildrenAndSupport = 'children-and-support',
  Animals = 'animals',
  Health = 'health',
}

const charityCategories = [
  {value: 'None', name: 'None' },
  {value: CharityCategory.ChildrenAndSupport, name: 'Children & Support' },
  {value: CharityCategory.Animals, name: 'Animals' },
  {value: CharityCategory.Health, name: 'Health & Mental Wellbeing' },
];

export const CharityCreateModal = ({
  closeModal,
  showModal,
  charity,
  action,
  refresh,
}: Props) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const date = new Date();
  date.setFullYear(date.getFullYear() + 30);
  const futureDateString = date.toISOString().split('T')[0];
  const [state, setState] = useState<Charity>({
    _id: charity?._id || '',
    name: charity?.name || '',
    isActiveOnCheckoutPage: charity ? charity.isActiveOnCheckoutPage : false,
    isActiveOnCharityPage: charity ? charity.isActiveOnCharityPage : false,
    description: charity?.description || '',
    landingTag: charity?.landingTag || '',
    image: charity?.image || '',
    thumbnailImage: charity?.thumbnailImage || '',
    charityUrl: charity?.charityUrl || '',
    landingUrl: charity?.landingUrl || '',
    value: charity?.value || '',
    createdAt: new Date(),
    category: charity?.category ?? charityCategories[0].value
  });

  const [categories, setCategories] = useState({
    selectedCategory: { id: '', title: '' },
    selectedSubCategory: { id: '', title: '' },
    category: Array<SelectCategories>(),
    subCategory: Array<SelectCategories>(),
  });

  const [fixedOdds, setFixedOdds] =
    useState<Array<{ id: string; title: string; maxTickets: number }>>();

  const [product, setProduct] = useState({
    products: Array<{ id: string; title: string }>(),
  });

  const [dreamHomes, setDreamHomes] = useState({
    dreamHomes: Array<{ id: string; title: string }>(),
  });

  const [touchState, setTouch] = useState({
    name: false,
  });
  // const [image, setImage] = useState<any>({
  //   img: charity?.image
  //     ? {
  //         id: charity.image,
  //         url: `${process.env.REACT_APP_AWS_S3_URL}/${charity.image}`,
  //         localUrl: null,
  //         isUploading: null,
  //         file: null,
  //         Key: charity.image,
  //       }
  //     : {
  //         id: null,
  //         url: null,
  //         localUrl: null,
  //         isUploading: null,
  //         file: null,
  //         Key: null,
  //       },
  //   status: 'initial',
  //   error: '',
  // });
  const { image, needRemoveImage, uploadImage, selectImage, removeImage } =
    useCharityImage({
      image: charity?.image
        ? {
            id: charity.image,
            url: `${process.env.REACT_APP_AWS_S3_URL}/${charity.image}`,
            localUrl: null,
            file: null,
          }
        : {
            id: null,
            url: null,
            localUrl: null,
            file: null,
          },
    });
  const [thumbnailImage, setThumbnailImage] = useState({
    img: charity?.thumbnailImage
      ? {
          id: charity.thumbnailImage,
          url: `${process.env.REACT_APP_AWS_S3_URL}/${charity.thumbnailImage}`,
          localUrl: null,
          isUploading: null,
          file: null,
          Key: charity.thumbnailImage,
        }
      : {
          id: null,
          url: null,
          localUrl: null,
          isUploading: null,
          file: null,
          Key: null,
        },
    status: 'initial',
  });
  const [errors, setErrors] = useState({
    name: { status: false, message: '' },
    charityUrl: { status: false, message: '' },
    landingUrl: { status: false, message: '' },
    landingTag: { status: false, message: '' },
    value: { status: false, message: '' },
    startDate: { status: false, message: '' },
    finishDate: { status: false, message: '' },
    image: { status: false, message: '' },
    thumbnailImage: { status: false, message: '' },
  });

  useEffect(() => {
    setErrors({
      ...errors,
      name: {
        status: state.name.trim().length === 0 ? true : false,
        message: 'Field is required',
      },
      image: {
        status: !image.file && !image.url ? true : false,
        message: 'Image is required',
      },
    });
  }, [state]);

  useEffect(() => {
    if (image.file || image.url) {
      setErrors((prev) => ({
        ...prev,
        image: { status: false, message: '' },
      }));
    }
  }, [image]);

  const handleChangeCharityPageStatus = () => {
    setState((state) => ({
      ...state,
      isActiveOnCharityPage: !state.isActiveOnCharityPage,
    }));
  };
  const handleChangeCheckoutPageStatus = () => {
    setState((state) => ({
      ...state,
      isActiveOnCheckoutPage: !state.isActiveOnCheckoutPage,
    }));
  };
  const handleChange = (e: any) => {
    let name = e.currentTarget.name;
    let value = e.currentTarget.value;
    setTouch({
      ...touchState,
      [name]: true,
    });

    setErrors((state) => ({
      ...errors,
      [name]: { ...state[name], status: false },
    }));

    // if (name === 'startDate' || name === 'finishDate') {
    //   if (!value) {
    //     value = '';
    //   }
    //   setErrors({
    //     ...errors,
    //     startDate: { status: false, message: '' },
    //     finishDate: { status: false, message: '' },
    //   });

    //   if (name === 'startDate') {
    //     const validation = validateStartDate(value, state.finishDate);
    //     if (validation.isError) {
    //       setErrors({
    //         ...errors,
    //         startDate: { status: true, message: "Start date isn't valid" },
    //       });
    //     }
    //   }

    //   if (name === 'finishDate') {
    //     const validation = valdiateFinishDate(state.startDate, value);
    //     if (validation.isError) {
    //       setErrors({
    //         ...errors,
    //         finishDate: { status: true, message: "Finish date isn't valid" },
    //       });
    //     }
    //   }
    // }

    setState((state) => ({
      ...state,
      [name]: '' + value,
    }));
  };

  const trimValueOnBlur = (e) => {
    setState({
      ...state,
      [e.target.name]: state[e.target.name].trim(),
    });
  };

  const handleSaveCharity = async () => {
    if (!touchState.name && action === 'create') {
      setErrors({
        ...errors,
        name: { status: true, message: 'Field is required' },
      });
      notify('Please check fields ', 'error');
      return;
    }
    if (!image.file && !image.url) {
      setErrors({
        ...errors,
        image: { status: true, message: 'Image is required' },
      });
      notify('Please check fields ', 'error');
      return;
    }

    let withErrors = false;
    Object.keys(errors).map((key) => {
      if (errors[key].status) {
        withErrors = true;
        return;
      }
    });

    if (!withErrors) {
      let data = {
        ...state,
      };
      Object.keys(state).map((key) => {
        if (!data[key]) {
          delete data[key];
        }
      });

      data.isActiveOnCharityPage = state.isActiveOnCharityPage;
      data.isActiveOnCheckoutPage = state.isActiveOnCheckoutPage;
      data.charityUrl = state.charityUrl;
      data.landingTag = state.landingTag;
      data.landingUrl = state.landingUrl;
      data.description = state.description;
      data.value = state.value;
      data.category = state.category === 'None' ? '' : (state.category as string);
      // if (state.startDate) {
      //   data.startDate = new Date(state.startDate!).toUTCString();
      // }
      // if (state.finishDate) {
      //   data.finishDate = new Date(state.finishDate!).toUTCString();
      // }
      // if (needRemoveImage) {
      //   data.image = '';
      // }

      if (action === 'create') {
        try {
          const result = await dataProvider.addCharity('/charities', data);
          if (result.data) {
            notify('Charity added', 'info');
            if (image.file) {
              let uploadedImage = await uploadImage(
                result.data._id,
                image.file
              );
              console.log('uploadedImage: ', uploadedImage);
            }
            closeModal();
            refresh();
          }
        } catch (error) {
          notify(error.data.error, 'error');
        }
      }
      if (action === 'edit') {
        try {
          const result = await dataProvider.editCharity('/charities', data);
          if (result.data) {
            notify('Charity edited', 'info');
            if (image.file) {
              let uploadedImage = await uploadImage(
                result.data._id,
                image.file
              );
              console.log('uploadedImage: ', uploadedImage);
            }
            closeModal();
            refresh();
          }
        } catch (error) {
          notify(error.data.error, 'error');
        }
      }
    } else {
      notify('Please check fields ', 'error');
    }
  };

  const handleSelect = (event: React.ChangeEvent<{ name?: string ; value: unknown; }>) => {
    const name = event.target.name as string;
    const value = event.target.value as string;

    setState((state) => ({
      ...state,
      [name]: value,
    }));
  }

  return (
    <div>
      <ReactModal
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        appElement={document.getElementById('root')}
        onClose={closeModal}
        isOpen={showModal}
        contentLabel='Inline Styles Modal Example'
        className='globalModalWrapper'
        style={{
          overlay: {
            backgroundColor: 'rgba(9, 16, 29, 0.6)',
            zIndex: 10,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        <div className='couponModalContentWrapper'>
          <div className='modalHeader'>
            {action === 'create' ? (
              <span>Add Charity</span>
            ) : (
              <span>Edit Charity</span>
            )}
          </div>
          <div className='modalBody modalBody_create'>
            <div className='fieldsRow'>
              <div className='side'>
                <CharityImageUploader
                  label={'Select Charity Image'}
                  image={image}
                  onSelect={selectImage}
                  onRemove={removeImage}
                />
                {errors.image.status && (
                  <span className='fieldErrorMessage'>
                    {errors.image.message}
                  </span>
                )}
              </div>
            </div>

            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Show on checkout page'
                  fieldTemplate='inline'
                  field={
                    <Switch
                      checked={state.isActiveOnCheckoutPage}
                      onChange={handleChangeCheckoutPageStatus}
                      color='primary'
                      name='checkedB'
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                  }
                />
              </div>

              <div className='side'></div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Show on charity page'
                  fieldTemplate='inline'
                  field={
                    <Switch
                      checked={state.isActiveOnCharityPage}
                      onChange={handleChangeCharityPageStatus}
                      color='primary'
                      name='checkedB'
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                  }
                />
              </div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Name'
                  field={
                    <Box width={'100%'}>
                      <TextField
                        label=''
                        size='small'
                        variant='outlined'
                        type='text'
                        name='name'
                        error={errors.name.status}
                        onChange={handleChange}
                        value={state.name}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
                {errors.name.status && (
                  <span className='fieldErrorMessage'>
                    {errors.name.message}
                  </span>
                )}
              </div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Charity Url'
                  field={
                    <Box width={'100%'}>
                      <TextField
                        label=''
                        size='small'
                        variant='outlined'
                        type='text'
                        name='charityUrl'
                        error={errors.charityUrl.status}
                        onChange={handleChange}
                        value={state.charityUrl}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
                {errors.charityUrl.status && (
                  <span className='fieldErrorMessage'>
                    {errors.charityUrl.message}
                  </span>
                )}
              </div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Landing Page Url'
                  field={
                    <Box width={'100%'}>
                      <TextField
                        label=''
                        size='small'
                        variant='outlined'
                        type='text'
                        name='landingUrl'
                        error={errors.landingUrl.status}
                        onChange={handleChange}
                        value={state.landingUrl}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
                {errors.landingUrl.status && (
                  <span className='fieldErrorMessage'>
                    {errors.landingUrl.message}
                  </span>
                )}
              </div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Landing Tag for Orders'
                  field={
                    <Box width={'100%'}>
                      <TextField
                        label=''
                        size='small'
                        variant='outlined'
                        type='text'
                        name='landingTag'
                        error={errors.landingTag.status}
                        onChange={handleChange}
                        value={state.landingTag}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
                {errors.landingTag.status && (
                  <span className='fieldErrorMessage'>
                    {errors.landingTag.message}
                  </span>
                )}
              </div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Category'
                  field={
                    <Box width={'100%'}>
                      <Select
                        name="category"
                        label="Category"
                        fullWidth
                        variant="outlined"
                        value={state.category || 'None'}
                        className="selectInput"
                        onChange={handleSelect}
                      >
                        {charityCategories.map((i) => {
                          return <MenuItem value={i.value}>{i.name}</MenuItem>;
                        })}
                      </Select>
                    </Box>
                  }
                />
                {errors.landingTag.status && (
                  <span className='fieldErrorMessage'>
                    {errors.landingTag.message}
                  </span>
                )}
              </div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Ticket Selector Value'
                  field={
                    <Box width={'100%'}>
                      <TextField
                        label=''
                        size='small'
                        variant='outlined'
                        type='text'
                        name='value'
                        error={errors.value.status}
                        onChange={handleChange}
                        value={state.value}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
                {errors.value.status && (
                  <span className='fieldErrorMessage'>
                    {errors.value.message}
                  </span>
                )}
              </div>
            </div>
            <div className='fieldsRow'>
              <div className='side'>
                <CreateCouponField
                  fieldTitle='Description'
                  field={
                    <Box width={'100%'}>
                      <TextField
                        label=''
                        multiline
                        variant='outlined'
                        minRows ={5}
                        maxRows ={10}
                        type='text'
                        name='description'
                        onChange={handleChange}
                        value={state.description}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
              </div>
            </div>
          </div>
          <div className='modalFooter modalFooter_create'>
            <AppButton
              onClick={handleSaveCharity}
              size='long'
              text={action === 'create' ? 'Save' : 'Save'}
            />
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

interface CouponCreateField {
  fieldTitle: string;
  fieldTemplate?: 'inline' | 'default';
  field: React.ReactNode;
}
const CreateCouponField = ({
  fieldTitle,
  field,
  fieldTemplate,
}: CouponCreateField) => {
  return (
    <div className={fieldTemplate === 'inline' ? 'row inline' : 'row'}>
      <p className='fieldHeader'>{fieldTitle}</p>
      <div className='fieldWrapper'>{field}</div>
    </div>
  );
};
